(() => {
  function enhance(root) {
    if (root.dataset.layoutReady) return;
    const form = root.querySelector('form[id^="AddToCartForm"]');
    if (!form) return;
    const previews = [...form.querySelectorAll('.mockup-preview')];
    previews.forEach((preview, index) => {
      const slot = root.querySelector(index ? '[data-lovebirds-preview-slot2]' : '[data-lovebirds-preview-slot]');
      const warning = preview.previousElementSibling;
      const frame = document.createElement('div');frame.className = 'lovebirds-preview-frame';
      if (warning?.tagName === 'LABEL') warning.remove();
      frame.append(preview);slot.append(frame);
      const resize = () => {
        const width = Math.min(slot.clientWidth || 450, 650);
        frame.style.width = width + 'px';frame.style.height = 358 * width / 900 + 'px';
        preview.style.transform = 'scale(' + width/450 + ')';
      };
      resize();if (typeof ResizeObserver !== 'undefined') new ResizeObserver(resize).observe(slot);
      else window.addEventListener('resize', resize);
    });
    const format = form.querySelector('#variant-options').closest('.product-form__input');
    const first = document.createElement('fieldset');first.className = 'lovebirds-mug-person';
    const legend = document.createElement('legend');legend.className = 'lovebirds-mug-step-label';
    const badge = document.createElement('span');badge.className = 'step';badge.textContent = '2';badge.setAttribute('aria-hidden','true');
    legend.append(badge, document.createTextNode(JSON.parse(root.querySelector('[data-lovebirds-personalise]').textContent).mug1));
    first.append(legend);format.after(first);
    for (const selector of ['#mug-colour-1','#custom-name1','#customFontSelect1']) {
      const field = form.querySelector(selector).closest('.product-form__input');first.append(field);
    }
    const label = format.querySelector('.form__label');label.classList.add('lovebirds-mug-step-label');
    const one = document.createElement('span');one.className='step';one.textContent='1';one.setAttribute('aria-hidden','true');label.prepend(one);
    const notes = form.querySelector('#custom-message')?.closest('.product-form__input');
    if (notes) {const details=document.createElement('details');details.className='lovebirds-mug-notes';const summary=document.createElement('summary');summary.textContent=notes.querySelector('label').textContent.trim();notes.before(details);details.append(summary,notes);}
    const second = root.querySelector('[data-lovebirds-second-preview]');
    second.hidden = form.querySelector('#variant-options input:checked')?.value !== '51065352126776';
    const review=form.querySelector('[data-atelier-review]');if(review)review.open=true;
    root.dataset.layoutReady='true';
  }
  const init=()=>document.querySelectorAll('[data-lovebirds-mug]').forEach(enhance);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
